import React, { Component, Fragment } from 'react'
import { MenuItem, Button, Checkbox, Grid, TextField, FormControlLabel, RadioGroup, Radio } from '@material-ui/core';
import Calendar from 'react-calendar';
import AddCircleOutlineRoundedIcon from '@material-ui/icons/AddCircleOutlineRounded';
import isEmpty from 'lodash.isempty';
import 'react-calendar/dist/Calendar.css';
import '../../App.css'
import './style.css'
import NumberFormat from 'react-number-format';
import TodayIcon from '@material-ui/icons/Today';
import { DatePicker } from 'antd';
import 'antd/dist/antd.css'; // or 'antd/dist/antd.less'
import locale from 'antd/es/date-picker/locale/de_DE';
import moment from 'moment'


const dateFormat = 'DD.MM.YYYY';

export default class ProjectForm extends Component {
  state = {
    showStartCalendar: false,
    showEndCalendar: false,
    error: [],
    date: new Date(),
    comment: '',
  }

  // titleCase = (str) => {
  //   return str[0].toLowerCase().split(' ').map(function (word) {
  //     return word.replace(word[0], word[0].toUpperCase());
  //   }).join(' ');
  // }

  UNSAFE_componentWillReceiveProps = (nextProps) => {
    const { error_validation } = this.props
    if (nextProps.error_validation !== error_validation) {
      this.setState({ error: nextProps.error_validation })
    }
  }

  render() {
    const { dataObj, textInput, user_list_for_pm, handleFieldsChange, customer_list, branches_list, createProject, openDeleteDialog } = this.props
    const { error, comment } = this.state
    const isInactive = !Boolean(dataObj.active)
    const access_rights = JSON.parse(localStorage.getItem('access_right'))
    return (
      <Fragment>
        <div>
          {(Number(access_rights.projects_basedata_for_own) === 2 || Number(access_rights.projects_basedata_for_other) === 2) &&
            <div style={{ textAlign: 'right' }}>
              {
                dataObj.editMode ?
                  <div>
                    <Button variant="outlined" color="primary" className="m-10" onClick={createProject} >Speichern</Button>
                    <Button className="m-10" style={(Number(access_rights.projects_basedata_for_other) !== 2 && dataObj.forOther) || (Number(access_rights.projects_basedata_for_own) !== 2 && dataObj.forOwn) ?
                      { display: "none" } : {}} variant="outlined" color="primary" onClick={openDeleteDialog} >Löschen</Button>
                  </div>
                  : <Button style={(Number(access_rights.projects_basedata_for_own) !== 2 && Number(access_rights.projects_basedata_for_other) !== 2) ?
                    { display: "none" } : {}} variant="outlined" color="primary" className="m-10" onClick={createProject} >Hinzufügen</Button>
              }
            </div>
          }
        </div>
        <div
          style={{
            maxHeight: "calc(100vh - 300px)",
            overflowY: "auto",
            padding: "12px"
          }}
          className={`${(Number(access_rights.projects_basedata_for_other) !== 2 && Number(access_rights.projects_basedata_for_own) !== 2) ? "disableALlFields" : ""}`}>
          <Grid container spacing={1} >
            <Grid item xs={12}>
              <Grid container spacing={1}>
                <Grid item xs={3} style={{ paddingTop: '10px', fontSize: '14px', wordBreak: 'break-all' }}>
                  Projekt-Nr.
              </Grid>
                <Grid item xs={3}>
                  <TextField
                    inputProps={{
                      maxLength: 20
                    }}
                    disabled={isInactive || dataObj.externIntern === '0' ? true : false}
                    helperText={!isEmpty(error.projectno) ? error.projectno : ''} error={!isEmpty(error.projectno) ? true : false}
                    required fullWidth size="small"
                    value={dataObj.projectNumber}
                    onChange={(e) => {
                      handleFieldsChange(e, "projectNumber")
                      if (!isEmpty(error.projectno))
                        error.projectno = []
                    }
                    } variant="outlined" />
                </Grid>
                <Grid item xs={4}>
                  <div className="radioBtn">
                    <RadioGroup value={dataObj.externIntern}
                      disabled={isInactive}
                      onChange={(e) => {
                        if (!isEmpty(error.projectno))
                          error.projectno = []
                        handleFieldsChange(e, "externIntern")
                      }}
                    >
                      <FormControlLabel value="0" disabled={isInactive} control={<Radio />} label="extern" labelPlacement="start" />
                      <FormControlLabel value="1" disabled={isInactive} control={<Radio />} label="intern" labelPlacement="start" />
                    </RadioGroup>
                  </div>
                </Grid>
                <Grid item xs={2} className="text-right">
                  <span>aktiv</span>
                  <Checkbox
                    checked={Boolean(dataObj.active)}
                    color="primary"
                    onChange={(e) => handleFieldsChange(e, "active")}
                  />
                </Grid>
              </Grid>
              <Grid container spacing={1}>
                <Grid item xs={3} style={{ paddingTop: '10px', fontSize: '14px', wordBreak: 'break-all' }}>
                  Projektname
                      </Grid>
                <Grid item xs={9}>
                  <TextField required fullWidth size="small"
                    inputRef={textInput}
                    inputProps={{
                      maxLength: 60
                    }}
                    helperText={!isEmpty(error.projectname) ? error.projectname : ''} error={!isEmpty(error.projectname) ? true : false}
                    value={dataObj.projectName}
                    disabled={isInactive}
                    onChange={(e) => {
                      handleFieldsChange(e, "Projektname")
                      if (!isEmpty(error.projectname))
                        error.projectname = []
                    }} variant="outlined" />
                </Grid>
              </Grid>
              <Grid container spacing={1}>
                <Grid item xs={3} style={{ paddingTop: '10px', fontSize: '14px', wordBreak: 'break-all' }}>
                  Kunde
              </Grid>
                <Grid item xs={9}>
                  <TextField
                    helperText={!isEmpty(error.customer) ? error.customer : ''} error={!isEmpty(error.customer) ? true : false}
                    value={dataObj.kunde}
                    select
                    variant="outlined"
                    className="select-box"
                    size="small"
                    fullWidth
                    disabled={isInactive}
                    onChange={(e) => {
                      if (!isEmpty(error.customer))
                        error.customer = []
                      handleFieldsChange(e, "kunde")
                    }}
                  >
                    {customer_list &&
                      customer_list.map(customer => {
                        if (customer.active)
                          return <MenuItem key={customer.id} value={customer.id}>{customer.name}</MenuItem>

                      })
                    }
                  </TextField>
                </Grid>
              </Grid>
              <Grid container spacing={1}>
                <Grid item xs={3} style={{ paddingTop: '10px', fontSize: '14px', wordBreak: 'break-all' }}>
                  Branche
              </Grid>
                <Grid item xs={9}>
                  <TextField
                    helperText={!isEmpty(error.branch) ? error.branch : ''} error={!isEmpty(error.branch) ? true : false}
                    value={dataObj.branche}
                    select
                    variant="outlined"
                    className="select-box"
                    size="small"
                    fullWidth
                    disabled={isInactive}
                    onChange={(e) => {
                      if (!isEmpty(error.branch))
                        error.branch = []
                      handleFieldsChange(e, "branche")
                    }}
                  >
                    {branches_list &&
                      branches_list.map(branch => (
                        <MenuItem key={branch.id} value={branch.id}>{branch.name}</MenuItem>
                      ))
                    }
                  </TextField>
                </Grid>
              </Grid>
              <Grid container spacing={1}>
                <Grid item xs={3} style={{ paddingTop: '10px', fontSize: '14px', wordBreak: 'break-all' }}>
                  Geschäftsführung
              </Grid>
                <Grid item xs={9}>
                  <TextField required fullWidth size="small"
                    helperText={!isEmpty(error.branch) ? error.branch : ''} error={!isEmpty(error.branch) ? true : false}
                    inputProps={{
                      maxLength: 60
                    }}
                    value={dataObj.managment}
                    disabled={isInactive}
                    onChange={(e) => handleFieldsChange(e, "managment")} variant="outlined" />
                </Grid>
              </Grid>
              <Grid container spacing={1}>
                <Grid item xs={3} style={{ paddingTop: '10px', fontSize: '14px', wordBreak: 'break-all' }}>
                  Projektleitung
              </Grid>
                <Grid item xs={9}>
                  <TextField required fullWidth size="small"
                    inputProps={{
                      maxLength: 60
                    }}
                    value={dataObj.projectManagement}
                    disabled={isInactive}
                    onChange={(e) => handleFieldsChange(e, "projectmanagement")} variant="outlined" />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <Grid container spacing={1}>
            <Grid item xs={3} style={{ paddingTop: '10px', fontSize: '14px', wordBreak: 'break-all' }}>
              Projektleitung LC
              </Grid>
            <Grid item xs={9}>
              <TextField
                helperText={!isEmpty(error.project_manager) ? error.project_manager : ''} error={!isEmpty(error.project_manager) ? true : false}
                value={dataObj.projectmanager}
                select
                variant="outlined"
                className="select-box"
                size="small"
                fullWidth
                disabled={isInactive}
                onChange={(e) => {
                  if (!isEmpty(error.project_manager))
                    error.project_manager = []
                  handleFieldsChange(e, "projectmanager")
                }}
              >
                {user_list_for_pm &&
                  user_list_for_pm.map(pm => (
                    <MenuItem key={pm.id} value={dataObj.projectmanager === pm.id ? pm.id : pm}>{pm.full_name}</MenuItem>
                  ))
                }
              </TextField>
            </Grid>
          </Grid>
          <div className="morefield">
            <Grid container justify="space-between" spacing={1}>
              <Grid item xs={6}>
                <Grid container spacing={1}>
                  {/* {((Number(access_rights.projects_setting_for_other) !== 0 && dataObj.forOther) || (Number(access_rights.projects_setting_for_own) !== 0 && dataObj.forOwn)) && */}
                  <Fragment>
                    <Grid item xs={6} style={{ paddingTop: '10px', fontSize: '14px', wordBreak: 'break-all' }}>
                      Projektwahrscheinlichkeit
                </Grid>
                    <Grid item xs={4}>
                      <TextField
                        value={dataObj.probability === '1.0' ? 1 : dataObj.probability}
                        select
                        disabled={isInactive || (((Number(access_rights.projects_setting_for_other) === 2 && dataObj.forOther) || Number(access_rights.projects_setting_for_own) === 2 || (Number(access_rights.projects_setting_for_own) === 2 && dataObj.forOwn)) ? false : true)}
                        variant="outlined"
                        className="select-box"
                        style={(Number(access_rights.projects_setting_for_other) !== 0 && dataObj.forOther) || (Number(access_rights.projects_setting_for_own) !== 0 && dataObj.forOwn) ? { pointerEvents: "auto", opacity: "1" } : {}}
                        size="small"
                        fullWidth
                        onChange={(e) => handleFieldsChange(e, "probability")}
                      >
                        <MenuItem value={0.75}>75%</MenuItem>
                        <MenuItem value={1}>100%</MenuItem>
                      </TextField>
                    </Grid>
                  </Fragment>
                  {/* } */}
                </Grid>

              </Grid>
              <Grid item xs={6}>
                <Grid container spacing={1}>
                  <Grid item xs={6} style={{ paddingTop: '10px', fontSize: '14px', wordBreak: 'break-all' }}>
                    Kürzel
                </Grid>
                  <Grid item xs={6} style={{ display: 'flex' }} className="app-calendar">
                    <TextField required size="small"
                      inputProps={{
                        maxLength: 2
                      }}
                      helperText={!isEmpty(error.shortcut) ? error.shortcut : ''} error={!isEmpty(error.shortcut) ? true : false}
                      value={dataObj.shortcut}
                      disabled={isInactive}
                      onChange={(e) => {
                        handleFieldsChange(e, "shortcut")
                        if (!isEmpty(error.shortcut))
                          error.shortcut = []
                      }} variant="outlined" />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            <Grid container justify="space-between" spacing={1}>
              <Grid item xs={6}>
                <Grid container spacing={1}>
                  <Grid item xs={6} style={{ paddingTop: '10px', fontSize: '14px', wordBreak: 'break-all' }}>
                    Toleranz Stundenerfassung
                </Grid>
                  <Grid item xs={4} className='tageFiedl'>
                    <NumberFormat
                      inputProps={{
                        maxLength: 40
                      }}
                      customInput={TextField}
                      className="innerInput rightToLeft"
                      required={true}
                      variant="outlined"
                      helperText={!isEmpty(error.toleranceregistering) ? error.toleranceregistering : ''} error={!isEmpty(error.toleranceregistering) ? true : false}
                      value={dataObj.toleranceRegistering}
                      thousandSeparator='.'
                      decimalSeparator=","
                      decimalScale={false}
                      allowNegative={false}
                      disabled={isInactive}
                      onChange={(e) => {
                        handleFieldsChange(e, "toleranceregistering")
                        if (!isEmpty(error.toleranceregistering))
                          error.toleranceRegistering = []
                      }
                      }
                    />
                    <span>Tage</span>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={6}>
                <Grid container spacing={1}>
                  <Grid item xs={5} style={{ paddingTop: '10px', fontSize: '14px', wordBreak: 'break-all' }}>
                    Projektreferenz
                </Grid>
                  <Grid item xs={2} align='right'>
                    <Checkbox
                      checked={dataObj.reference === 1 ? true : false}
                      color="primary"
                      disabled={isInactive}
                      onChange={(e) => handleFieldsChange(e, "reference")}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            <Grid container justify="space-between" spacing={1}>
              <Grid item xs={6}>
                <Grid container spacing={1}>
                  <Grid item xs={6} style={{ paddingTop: '10px', fontSize: '14px', wordBreak: 'break-all' }}>
                    Toleranz Planung
                </Grid>
                  <Grid item xs={4} className='tageFiedl'>
                    <NumberFormat
                      customInput={TextField}
                      className="innerInput rightToLeft"
                      required={true}
                      inputProps={{
                        maxLength: 40
                      }}
                      variant="outlined"
                      helperText={!isEmpty(error.toleranceplaning) ? error.toleranceplaning : ''} error={!isEmpty(error.toleranceplaning) ? true : false}
                      value={dataObj.tolerancePlanning}
                      thousandSeparator='.'
                      decimalSeparator=","
                      decimalScale={false}
                      disabled={isInactive}
                      onChange={(e) => {
                        if (!isEmpty(error.toleranceplaning))
                          error.toleranceplaning = []
                        handleFieldsChange(e, "toleranceplanning")
                      }}
                    />
                    <span>Tage</span>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={6}>
                <Grid container spacing={1}>
                  <Grid item xs={5} style={{ paddingTop: '10px', fontSize: '14px', wordBreak: 'break-all' }}>
                    Geheimhaltungsvereinbarung
                </Grid>
                  <Grid item xs={2} align='right'>
                    <Checkbox
                      checked={dataObj.secret === 1 ? true : false}
                      color="primary"
                      disabled={isInactive}
                      onChange={(e) => handleFieldsChange(e, "secret")}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            <Grid container justify="space-between" spacing={1}>
              <Grid item xs={6}>
                <Grid container spacing={1}>
                  <Grid item xs={6} style={{ paddingTop: '10px', fontSize: '14px', wordBreak: 'break-all' }}>
                    Stunden / Tag
                </Grid>
                  <Grid item xs={4} className='tageFiedl'>
                    <NumberFormat
                      customInput={TextField}
                      className="innerInput rightToLeft"
                      required={true}
                      inputProps={{
                        maxLength: 40
                      }}
                      variant="outlined"
                      helperText={!isEmpty(error.hoursperday) ? error.hoursperday : ''} error={!isEmpty(error.hoursperday) ? true : false}
                      value={dataObj.hoursperday}
                      thousandSeparator='.'
                      decimalSeparator=","
                      decimalScale="2"
                      allowNegative={false}
                      disabled={isInactive}
                      onChange={(e) => {
                        handleFieldsChange(e, "hoursperday")
                        if (!isEmpty(error.hoursperday))
                          error.hoursperday = []
                      }}
                    />
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={6}>
                <Grid container spacing={1}>
                  <Grid item xs={6} style={{ paddingTop: '10px', fontSize: '14px', wordBreak: 'break-all' }}>
                    archiviert am
                </Grid>
                  <Grid item xs={6} style={{ display: 'flex' }} className="app-calendar">
                    <DatePicker
                      locale={locale}
                      value={dataObj.archived === "" ? '' : moment(dataObj.archived, dateFormat)}
                      format={dateFormat}
                      placeholder="DD.MM.YYYY"
                      bordered={false}
                      disabled={isInactive}
                      onChange={(e) => {
                        handleFieldsChange(e, "archived")
                      }} />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            <Grid container justify="space-between" spacing={1}>
              <Grid item xs={6}>
                <Grid container spacing={1}>
                  <Grid item xs={12} style={{ paddingTop: '10px', fontSize: '14px', wordBreak: 'break-all' }}>
                    Bemerkungen
                </Grid>
                  <Grid item xs={12} className="d-flex textarea-field">
                    <TextField required fullWidth multiline rows={5}
                      variant="outlined"
                      value={dataObj.comment}
                      disabled
                    />
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={6}>
                <Grid container spacing={1}>
                  <Grid item xs={12} style={{ paddingTop: '10px', fontSize: '14px', wordBreak: 'break-all' }}>
                    Rechnungsanschrift
                </Grid>
                  <Grid item xs={12} className="d-flex textarea-field">
                    <TextField required fullWidth multiline rows={5}
                      variant="outlined" value={dataObj.invoiceaddress}
                      disabled={isInactive}
                      onChange={(e) => handleFieldsChange(e, "invoiceaddress")}
                    />

                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            <Grid container spacing={1}>
              <Grid item xs={6}>
                <div className="addmorefield">
                  <TextField required fullWidth size="small"
                    value={comment}
                    disabled={isInactive}
                    onChange={(e) => this.setState({ comment: e.target.value })}
                    variant="outlined" />

                  <AddCircleOutlineRoundedIcon onClick={() => {
                    isInactive || handleFieldsChange(comment, "comment")
                    this.setState({ comment: '' })
                  }} style={{ fontSize: 30, marginLeft: 5 }} />
                </div>

              </Grid>
            </Grid>

            <br />
            <br />
          </div>
        </div >
      </Fragment>
    )
  }
}
